var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-editor-container"},[_c('editor-content',{staticClass:"can-scroll-y content-editor",attrs:{"editor":_vm.editor,"disabled":_vm.disabled}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }